import { CommonApi } from "api/common.api";
import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import Select from "react-select";
import { areasApi } from "../api/Areas.api";
import ActivityLoader from "activity/componenets/ActivityLoader";
import useGetCititesHook from "../hooks/useGetCititesHook.hook";

const AddAreaModal = ({ show, onHide }) => {
  const [name, setName] = useState("");
  const [cityId, setCityId] = useState(1);
  const { citiesState, city, setCity } = useGetCititesHook();
  const [addArea, { isLoading }] = areasApi.useAddAreaMutation();

  const [defaultCityId, setDefaultCityId] = useState(null);

  const handleSubmit = async () => {
    if (!name) return toast.error("Please fill the name");
    await addArea({ name, cityId });
    setName("");
    setCity("");
    onHide();
  };

  React.useEffect(() => {
    if (defaultCityId === null && citiesState.length) {
      const match: any = citiesState.find(
        (city) =>
          typeof city.label === "string" &&
          city.label.toLowerCase().includes("dubai")
      );

      setDefaultCityId(match);
    }
  }, [citiesState]);

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Add New Area</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="areaName">
            <Form.Label>Area Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter area name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Form.Group>
          <Form.Group controlId="cityName" className="mt-3">
            <Form.Label>City Name</Form.Label>
            <Select
              onInputChange={(val) => setCity(val)}
              defaultValue={defaultCityId ? defaultCityId : citiesState[0]}
              onChange={(val: any) => setCityId(val.value)}
              inputValue={city}
              placeholder="Search Cities"
              options={citiesState}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        {isLoading ? (
          <ActivityLoader />
        ) : (
          <>
            <Button variant="secondary" className="btn-flat" onClick={onHide}>
              Cancel
            </Button>
            <Button
              variant="primary"
              className="btn-flat"
              onClick={handleSubmit}
            >
              Add Area
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default AddAreaModal;
